// extracted by mini-css-extract-plugin
export default {"page":"lI","top_block":"mI","heading":"nI","inner_text":"oI","starter_text":"pI","starter_cta":"qI","summary_block":"rI","cartsummary_wrap":"sI","price":"tI","pricing_wrap":"uI","summary_block_mob":"vI","summary":"wI","pricing_heading":"xI","products_summary":"yI","summary_line":"zI","summary_price":"AI","summary_title":"BI"};
    if(module.hot) {
      // 1738836197083
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  